import { COMICS } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function NewArrivals() {
  const arrivals = COMICS.filter((c) => c.newArrival);
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="新作尝鲜"
          title="新作尝鲜，抢先挖掘潜力好货"
          desc="刚上架的新鲜作品，编辑抢先试读，帮你把真正的好货挑出来。"
          to="/category/qiHuan"
          linkText="更多新作"
        />
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-5">
          {arrivals.map((c) => (
            <ComicCard key={c.id} comic={c} />
          ))}
        </div>
      </div>
    </section>
  );
}